import { Component } from "react";

/**
 * Faengt Fehler beim Rendern ab und zeigt sie an, statt die Seite leer zu lassen.
 *
 * React verhaelt sich hier unbarmherzig: Wirft eine Komponente beim Rendern
 * eine Ausnahme, haengt React den GESAMTEN Baum ab. Uebrig bleibt eine weisse
 * Seite - ohne Meldung, ohne Hinweis, wo es passiert ist.
 *
 * Der Faenger in index.html hilft dabei nicht: Er greift nur, solange React
 * noch gar nichts gerendert hat. Bricht es nach der Anmeldung ab, steht dort
 * bereits ein Baum, und der Faenger haelt sich zurueck.
 *
 * Genau diese Luecke traf den Anmeldeweg auf dem Telefon: Anmeldebildschirm
 * da, Google-Anmeldung erfolgreich, danach weiss. Zwischen beidem liegt der
 * Aufbau von Menue und Uebersicht - und ein Fehler darin war von aussen nicht
 * zu unterscheiden von "die Anwendung laedt nicht".
 *
 * Angezeigt wird der Fehlertext samt Browser-Kennung. Das ist bewusst
 * technisch: Wer es liest, will es weitergeben koennen.
 */
export default class Fehlerfang extends Component {
  constructor(props) {
    super(props);
    this.state = { fehler: null, stelle: null };
  }

  static getDerivedStateFromError(fehler) {
    return { fehler };
  }

  componentDidCatch(fehler, info) {
    this.setState({ stelle: info?.componentStack });
    // Auch ins Protokoll, falls jemand die Entwicklerkonsole offen hat.
    console.error("Fehler beim Rendern:", fehler, info);
  }

  render() {
    if (!this.state.fehler) return this.props.children;

    const { fehler, stelle } = this.state;
    const text = [
      fehler?.stack || String(fehler),
      stelle ? `\nBetroffen:${stelle}` : "",
    ].join("");

    return (
      <div className="min-h-screen bg-slate-50 px-4 py-10">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-lg font-semibold text-slate-900">
            Da ist etwas schiefgegangen
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Die Ansicht konnte nicht aufgebaut werden. Ein Neuladen hilft oft
            schon. Bleibt es dabei, hilft der Text unten bei der Fehlersuche –
            er lässt sich markieren und weitergeben.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => window.location.reload()}
              className="h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-medium"
              data-testid="fehler-neuladen"
            >
              Neu laden
            </button>
            <button
              onClick={() => { window.location.href = "/login"; }}
              className="h-9 px-3 rounded-md border border-slate-300 text-slate-700 text-sm font-medium"
              data-testid="fehler-anmeldung"
            >
              Zur Anmeldung
            </button>
          </div>

          <pre className="mt-4 whitespace-pre-wrap break-words rounded-md bg-slate-100
                          p-3 text-xs leading-relaxed text-slate-700"
               data-testid="fehler-text">
            {text}
          </pre>

          <p className="mt-3 break-words text-xs text-slate-400">
            {typeof navigator !== "undefined" ? navigator.userAgent : ""}
          </p>
        </div>
      </div>
    );
  }
}
